import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const getMetrics = async () => {
  return await apiClient.get(ENDPOINTS.METRICS);
};
